export class DuplicateValueDefinitionIdError extends Error {
  constructor() {
    super(`All value IDs must be unique`);
    this.name = 'DuplicateValueDefinitionIdError';
  }
}
